import { AutocompleteInput, FormDataConsumer, ReferenceInput, required, SelectInput } from "react-admin";
import AcademicYearInput from "./Inputs/AcademicYearInput";
import { Grid } from "@mui/material";
import LanguageSelectInput from "./Inputs/LanguageSelectInput";
import AcademicYearSessionInput from "./Inputs/AcademicYearSessionInput";
import DisciplineSelectInput from "./Inputs/DisciplineSelectInput";

import { StudyTypes } from "utils/constants";
import CurriculumSelectInput from "./Inputs/CurriculumSelectInput";
import { useFormContext } from "react-hook-form";
import { administrationRequests } from "api/administrationApi";

const DependentFilterBlock = ({ defaultValues }) => {
  const { setValue } = useFormContext();

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={6}
        sm={6}
        xs={12}
      >
        <FormDataConsumer>
          {({ formData }) => (
            <ReferenceInput
              source="specialityId"
              reference={administrationRequests.getSpecialitiesSelect()}
            >
              <AutocompleteInput
                label="Специалност"
                filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                defaultValue={formData.specialityId || defaultValues.specialityId}
                optionText="name"
                validate={[required()]}
                readOnly={formData.specialityId === defaultValues.specialityId && !!defaultValues.specialityId}
                onChange={() => {
                  setValue("curriculumId", null);
                  setValue("instructionLanguageId", null);
                  setValue("academicYearId", null);
                  setValue("studyTypeId", null);
                  setValue("academicYearSessionId", null);
                  setValue("disciplineId", null);
                }}
              />
            </ReferenceInput>
          )}
        </FormDataConsumer>
      </Grid>
      <Grid
        item
        md={6}
        xs={12}
      >
        <FormDataConsumer>
          {({ formData }) =>
            formData.specialityId && (
              <CurriculumSelectInput
                key={formData.curriculumId}
                defVal={formData.curriculumId || defaultValues.curriculumId}
                readOnly={formData.curriculumId === defaultValues.curriculumId && !!defaultValues.curriculumId}
              />
            )
          }
        </FormDataConsumer>
      </Grid>

      <Grid
        item
        md={6}
        xs={12}
      >
        <FormDataConsumer>
          {({ formData }) =>
            formData.curriculumId && (
              <LanguageSelectInput
                defVal={formData.instructionLanguageId || defaultValues.instructionLanguageId}
                readOnly={
                  formData.instructionLanguageId === defaultValues.instructionLanguageId &&
                  !!defaultValues.instructionLanguageId
                }
              />
            )
          }
        </FormDataConsumer>
      </Grid>

      <Grid
        item
        md={6}
        xs={12}
      >
        <FormDataConsumer>
          {({ formData }) =>
            formData.instructionLanguageId && (
              <AcademicYearInput
                defVal={formData.academicYearId || defaultValues.academicYearId}
                readOnly={formData.academicYearId === defaultValues.academicYearId && !!defaultValues.academicYearId}
              />
            )
          }
        </FormDataConsumer>
      </Grid>

      <Grid
        item
        md={6}
        xs={12}
      >
        <FormDataConsumer>
          {({ formData }) =>
            formData.academicYearId && (
              <ReferenceInput
                source="studyTypeId"
                label="Вид на обучение"
                reference={administrationRequests.getStudyTypesSelect()}
              >
                <SelectInput
                  onChange={() => {
                    setValue("academicYearSessionId", null);
                    setValue("disciplineId", null);
                  }}
                  optionText="name"
                  label="Вид на обучение"
                  validate={required()}
                  defaultValue={formData.studyTypeId || defaultValues.studyTypeId || StudyTypes.Full_time}
                  emptyText={false}
                  readOnly={formData.studyTypeId === defaultValues.studyTypeId && !!defaultValues.studyTypeId}
                  fullWidth
                />
              </ReferenceInput>
            )
          }
        </FormDataConsumer>
      </Grid>

      <Grid
        item
        md={6}
        xs={12}
      >
        <FormDataConsumer>
          {({ formData }) =>
            formData.studyTypeId && (
              <AcademicYearSessionInput
                defVal={formData.academicYearSessionId || defaultValues.academicYearSessionId}
                readOnly={
                  formData.academicYearSessionId === defaultValues.academicYearSessionId &&
                  !!defaultValues.academicYearSessionId
                }
                curriculumId={formData.curriculumId}
                instructionLanguageId={formData.instructionLanguageId}
                academicYearId={formData.academicYearId}
                studyTypeId={formData.studyTypeId}
              />
            )
          }
        </FormDataConsumer>
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <FormDataConsumer>
          {({ formData }) =>
            formData.curriculumId &&
            formData.academicYearSessionId && (
              <DisciplineSelectInput
                defVal={formData.disciplineId || defaultValues.disciplineId}
                readOnly={formData.disciplineId === defaultValues.disciplineId && !!defaultValues.disciplineId}
              />
            )
          }
        </FormDataConsumer>
      </Grid>
    </Grid>
  );
};

export default DependentFilterBlock;
